import { useState, useEffect, useContext } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { getProductsBelongCategory } from "../apis/product";
import useProductCategory from "./useProductCategory";
import { CategorySlugContext } from "../context";

const usePaginatedProduct = (sortBy: string) => {
  const slug = useContext(CategorySlugContext);
  const [currentPage, setCurrentPage] = useState(1);
  const queryClient = useQueryClient();

  const productQuery = useProductCategory(currentPage, sortBy);

  useEffect(() => {
    queryClient.prefetchQuery(
      [
        "ProductsByCategory",
        { page: currentPage + 1, slug: slug, sort: sortBy },
      ],
      () => getProductsBelongCategory(currentPage + 1, slug, sortBy)
    );
  }, [currentPage, queryClient, slug, sortBy]);

  const handlePageChange = (newPage: number) => {
    setCurrentPage(newPage);
  };

  return {
    currentPage,
    handlePageChange,
    productQuery,
  };
};

export default usePaginatedProduct;
